import React, { useMemo } from 'react';
import SearchHit from './SearchHit';
import useSearchPagination from './hooks/useSearchPagniation';

const SearchHits = ( { indexName } ) => {
	const { hitsForPage, isLastPage, showMore, page } = useSearchPagination();

	const loadMoreHref = useMemo( () => {
		const url = new URL( window.location.href );
		url.searchParams.set( 'page', page + 1 );
		return url;
	}, [ page ] );

	if ( ! hitsForPage ) {
		return null;
	}

	return (
		<div className='tw-mb-16'>
			<div className="tw-grid tw-grid-cols-12 tw-gap-6">
				{hitsForPage.map( ( hit, index ) => {
					return (
						<div className="tw-col-span-12 md:tw-col-span-6" key={index}>
							<SearchHit
								hit={hit}
								indexName={indexName}
							/>
						</div>
					);
				} )}
			</div>

			{! isLastPage && (
				<div className='tw-flex tw-justify-center tw-my-8'>
					<a
						href={loadMoreHref}
						aria-label={`Load page ${ page + 1 }`}
						onClick={( e ) => {
							e.preventDefault();
							showMore();
						}}
						className='btn-solid btn-solid--apple'>
							Load More
					</a>
				</div>
			)}
		</div>
	);
};

export default SearchHits;
